import React from 'react'

const PhotosContext = React.createContext()

export default PhotosContext
